module.exports = __webpack_public_path__ + "static/media/how_it_works_schedule_your_pickup_icon.23956cb7.png";